import {
  ACTION_LOAD_SITE_FOOTER_LINKS__REQUEST,
  ACTION_LOAD_SITE_FOOTER_LINKS__SUCCESS,
  ACTION_LOAD_SITE_FOOTER_LINKS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_SITE_FOOTER_LINKS__REQUEST:
    case ACTION_LOAD_SITE_FOOTER_LINKS__SUCCESS:
      return null;

    case ACTION_LOAD_SITE_FOOTER_LINKS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
